import Button from 'components/button/Button'
import { formatDate } from 'helper/dateFormat'
import { getCurrency, numberFormat } from 'helper/numberFormat'
import moment from 'moment'
import React from 'react'
import BulkClassBox from '../ClassBox/BulkClassBox'
import { DashLine, Description, DescriptionText, EventTitle, Note, PayDetails, ReserveAction, RightSideContent, RightSideWrappr, SchoolCaption, SchoolName } from './Theme'

const ViewClassInfoModal = ({
  classDetails,
  closeModal,
  onSelectClass,
}) => {
  const currency = getCurrency();


  const isExpiredEvent = () => {
    const startDateDiff = moment().diff(moment(classDetails?.class_start_date), 'days');
    const endDateDiff = moment().diff(classDetails?.class_end_date ? moment(classDetails?.class_end_date) : moment(), 'days');

    return startDateDiff < 0 || endDateDiff > 0
  }

  const handleDifferanceDate = () => {
    const date1 = new Date();
    const date2 = new Date(classDetails?.class_end_date);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays === 1 ? <span>{diffDays} Day  left!</span>
      : <span>{diffDays} Days  left!</span>
  }

  return (
    <div
      style={{ width: "100%" }}
    >
      <RightSideContent
        style={{ width: "100%" }}
      >
        <EventTitle>
          <SchoolName>{classDetails?.class_name}</SchoolName>
          <SchoolCaption>
            {classDetails?.always_available ? 'Always Available' : <span>Registration ends  {formatDate({ date: classDetails?.class_end_date, formatType: "default" })}</span>}
            {isExpiredEvent() ? '' : !classDetails?.always_available && <div>{handleDifferanceDate()} </div>}
          </SchoolCaption>
        </EventTitle>

        <BulkClassBox 
          classDetails={classDetails}
        /><br />
        <Description>
          <span>Description</span>
          <DescriptionText>
            {classDetails?.description?.replace(/&lt;/g, '<') !== '<p></p>\n' && (
              <div className="drawer_description">
                <p
                  dangerouslySetInnerHTML={{
                    __html: classDetails?.description?.replace(/&lt;/g, '<'),
                  }}
                ></p>
              </div>
            )}

          </DescriptionText>
        </Description>

        <DashLine />
        <PayDetails>
          {classDetails?.class_pricing
            ?.prices?.map((item, index) => item?.type === "onRegistration" ? (<>
              <li key={index}>{item?.title}<span>{numberFormat({ number: +item.amount, decimal: 2, style: "currency" })}</span></li>
              <Note>{item?.note}</Note>
              <hr />
            </>
            )
              : <>
                <li key={index}>{item?.title} {item?.type === 'optional' && `(optional)`}
                  {item.type !== 'openAmount' && <span>{item?.amount > 0 ? `${numberFormat({ number: +item.amount, decimal: 2, style: "currency" })}` :
                    item?.variantAmountRange ? item?.variantAmountRange?.replaceAll("$", currency) : "0.00"}</span>}</li>
                <Note>{item?.note}</Note>
                <hr />
              </>
            )}
          {classDetails?.class_discount?.map((item, index) => (
            <>
              <li
                key={index}
                className={`d-flex flex-column gap-2`}
              >
                <div className="d-flex align-items-center justify-content-between">
                  {item?.discount_name}
                  {item?.discount_type === 'date' && ` | ${formatDate({ date: item?.start_date, formatType: "default" })}
                        -
                        ${formatDate({ date: item?.end_date, formatType: "default" })}`}
                  <span>
                    {item?.price_type === 'percentage' ? `${item?.value}%` : `${numberFormat({ number: +item?.value, decimal: 2, style: "currency" })}`}
                  </span>
                </div>
              </li>
              <hr />
            </>

          ))}

        </PayDetails>
        <br />
      </RightSideContent>
      <ReserveAction>
        <Button
          variant="primary-outline"
          onClick={closeModal}
          size="md"
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={onSelectClass}
          size="md"
        >
          Select Class
        </Button>
      </ReserveAction>
    </div>

  )
}

export default ViewClassInfoModal